export default __webpack_public_path__ + "static/media/pdf-regular-white.ade40ffe.svg";